import React, { useState, useEffect } from 'react';
import Editor from '@monaco-editor/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders, faCopy, faCloudArrowDown, faSearch } from '@fortawesome/free-solid-svg-icons';
import { 
  TbJson
} from "react-icons/tb";
import commonFunc from "./../../common"
import SmallModal from './../SmallModal'
import jsonpath from 'jsonpath';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { Link } from 'react-router-dom';

const { notifySuccess, notifyFailure } = commonFunc
var _ = require('lodash');

const activeClasses = 'w-40 inline-flex items-center px-4 py-3 text-white bg-blue-500 rounded-lg active dark:bg-blue-600'
const inactiveClasses = 'w-40 inline-flex items-center px-4 py-3 rounded-lg hover:text-gray-900 bg-gray-50 hover:bg-gray-100 w-full dark:bg-gray-800 dark:hover:bg-gray-700 dark:hover:text-white'
const exampleJson = `{
  "description": "Book Store",
  "book": [
    {
      "author": "Nigel Rees",
      "title": "Sayings of the Century",
      "price": 8.95
    },
    {
      "author": "Evelyn Waugh",
      "title": "Sword of Honour",
      "price": 12.99
    },
    {
      "title": "Moby Dick",
      "price": 8.99
    },
  ],
}`;
const CurrentSheet = (props) => {
  const { displaySheetData, sheetName, editorTheme } = props;
  const [activeTab, setActiveTab] = useState(0)
  const [currentSheetData, setCurrentSheetData] = useState(displaySheetData[sheetName])
  const [jsonQueryInput, setJsonQueryInput] = useState('');
  const [queryResult, setQueryResult] = useState()
  const getMappingKeys = (jsonData) => {
    const jsonKeys = {}
    if (!jsonData) {
      return jsonKeys
    }
    Object.keys(jsonData[0]).map((key) => {
      return jsonKeys[key] = key
    })
    return JSON.stringify(jsonKeys, null, 2)
  }
  const [mappingKeys, setMappingKeys] = useState(getMappingKeys(displaySheetData[sheetName]))

  const renderJsonAsHtml = (jsonData) => {
    return JSON.stringify(jsonData, null, 2)
  }

  const handleApplyKeyMapping = () => {
    try {
      const parsedJson = JSON.parse(mappingKeys);
      const updatedJson = currentSheetData.map((obj) => {
        let newObj = { ...obj }; // Create a shallow copy to avoid mutating the original object

        Object.keys(parsedJson).forEach((key) => {
          if (newObj.hasOwnProperty(key)) {
            newObj[parsedJson[key]] = newObj[key];
          }
        });

        return newObj;
      });
      // Filter the objects to only include the mapped keys
      const filteredData = updatedJson.map((item) => _.pick(item, Object.values(parsedJson)));
      setCurrentSheetData(filteredData)
      notifySuccess("Key Mapping applied successfully")
    } catch(err) {
      console.error(err)
      notifyFailure("Key Mapping invalid")
    }
  }

  const handleResetKeyMapping = () => {
    setCurrentSheetData(displaySheetData[sheetName])
    setMappingKeys(getMappingKeys(displaySheetData[sheetName]))
    notifySuccess("Key Mapping was reset")
  }

  const handleQuery = () => {
    if (!jsonQueryInput) {
      notifyFailure("Query syntax invalid")
      return
    }
    try {
      const jsonForQuery = currentSheetData
      const result = jsonpath.query(jsonForQuery, jsonQueryInput);
      setQueryResult(JSON.stringify(result, null, 2))
      notifySuccess("Your query was updated")
    } catch (error) {
      console.error(error);
      notifyFailure("Query syntax invalid")
    }
  }

  const removeFilter = () => {
    setQueryResult('')
    setJsonQueryInput('')
  }

  const copyToClipboard = () => {
    const coppiedData = JSON.stringify(currentSheetData, null, 2);
      navigator.clipboard.writeText(coppiedData);
  };

  const copyToQueryResultClipboard = () => {
      navigator.clipboard.writeText(queryResult);
  };

  const downloadJsonFile = () => {
    const jsonData = JSON.stringify(currentSheetData, null, 2);
      const blob = new Blob([jsonData], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${sheetName}.json`;
      a.click();
      URL.revokeObjectURL(url);
  };

  const downloadQueryResultFile = () => {
    const blob = new Blob(queryResult, { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${sheetName}_query.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const tipsContent = () => {
    return (
      <p className="text-lef">
        <b className='text-gray-500 dark:text-gray-300'>Example usage:</b> <br/><br/>
        <SyntaxHighlighter language="javascript">
          {exampleJson}
        </SyntaxHighlighter>
        <code class="language-javascript">
          $.book[*].title → titles of all the books <br/>
          $.book[?(@.price &gt; 10)] → books with price &gt; 10<br/>
          $.book[?(@.author)] → books with an author <br/>
          $.book[0,1] → first two books
        </code>
        <Link target='_blank' className='flex font-medium text-blue-600 dark:text-blue-500 hover:underline' to='https://github.com/json-path/JsonPath?tab=readme-ov-file'>Checkout Document</Link>
      </p>
    )
  }

  return (
    <div className="md:flex">
      <ul className="flex-column space-y space-y-4 text-sm font-medium text-gray-500 dark:text-gray-400 md:me-4 mb-4 md:mb-0">
        <li>
          <button
            onClick={() => setActiveTab(0)}
            className={activeTab === 0 ? activeClasses : inactiveClasses}
          >
            <TbJson style={{fontSize: 24}} className='svg-inline--fa fa-text-width' />&nbsp;View
          </button>
        </li>
        <li>
          <button
            onClick={() => setActiveTab(1)}
            className={activeTab === 1 ? activeClasses : inactiveClasses}
          >
            <FontAwesomeIcon icon={faSliders}/>&nbsp;Key Mapping
          </button>
        </li>
        <li>
          <button
            onClick={() => setActiveTab(2)}
            className={activeTab === 2 ? activeClasses : inactiveClasses}
          >
            <FontAwesomeIcon icon={faSearch}/>&nbsp;JSON Query
          </button>
        </li>
      </ul>
      <div className="p-6 bg-gray-50 text-medium text-gray-500 dark:text-gray-400 dark:bg-gray-800 rounded-lg w-full">
        { activeTab === 0 && (
          <div className='text-right'>
            <Editor
              value={renderJsonAsHtml(currentSheetData)}
              height="80vh"
              language="json"
              theme={editorTheme}
              className="block mb-4 p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
            <button
              onClick={copyToClipboard}
              type="button"
              className="text-white ml-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCopy}/>
              &nbsp; Copy JSON
            </button>
            <button
              onClick={downloadJsonFile}
              type="button"
              className="text-white ml-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCloudArrowDown}/>
              &nbsp; Download JSON file
            </button>
          </div>
        )}
        { activeTab === 1 &&
        (
          <div className='text-right'>
            <Editor
              onChange={(value, event) => setMappingKeys(value)}
              value={mappingKeys}
              height="40vh"
              language="json"
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
            <button
              type='button'
              onClick={handleResetKeyMapping}
              className="text-white mt-4 bg-gray-400 hover:bg-gray-500 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              Reset to default
            </button>
            <button
              type='button'
              onClick={handleApplyKeyMapping}
              className="text-white mt-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              Apply
            </button>
          </div>
        )}
        { activeTab === 2 &&
        (
          <div className='text-right'>
            <Editor
              onChange={(value, event) => setJsonQueryInput(value)}
              value={jsonQueryInput}
              height="20vh"
              language="java"
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
            <SmallModal title='JSON Query Tips' content={tipsContent()} />
            <button
              type='button'
              onClick={removeFilter}
              className="text-white mt-4 bg-gray-400 hover:bg-gray-500 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              Remove filter
            </button>
            <button
              onClick={handleQuery}
              disabled={!jsonQueryInput}
              type='button'
              className="text-white mt-3 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              Run
            </button>
            { queryResult && (
              <>
                <Editor
                  value={queryResult}
                  height="50vh"
                  language="json"
                  theme={editorTheme}
                  className="block mt-3 mb-4 p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
                <button
                  onClick={copyToQueryResultClipboard}
                  disabled={!queryResult}
                  type="button"
                  className="text-white ml-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
                >
                  <FontAwesomeIcon icon={faCopy}/>
                  &nbsp; Copy JSON
                </button>
                <button
                  onClick={downloadQueryResultFile}
                  disabled={!queryResult}
                  type="button"
                  className="text-white ml-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
                >
                  <FontAwesomeIcon icon={faCloudArrowDown}/>
                  &nbsp; Download JSON file
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default CurrentSheet;
